import { useEffect } from "preact/hooks";
import { AuthView } from "../../components/auth/AuthView";
import { targetAfterSignIn } from "../../components/auth/signInConfig";
import { useToast } from "../../contexts/ToastContext";
import { useIsSignedIn } from "../../platform/session";
import type { PageProps } from "../pageProps";

const ERROR_MESSAGES: Record<string, string> = {
  expired: "Your login attempt has expired. Please try again.",
  invalid_magic_link: "This magic link is invalid or has expired. Please request a new one.",
  unauthorized: "Please sign in to continue.",
};

/**
 * /auth - the sign-in page, and the redirect URI of the Google web flow (the view finishes the code exchange).
 * `?redirect=` is where to go afterwards (default `/`); `?error=` shows a message. A signed-in visitor is sent on.
 */
export const AuthPage = (_props: PageProps) => {
  const toast = useToast();
  const signedIn = useIsSignedIn();

  useEffect(() => {
    const error = new URLSearchParams(window.location.search).get("error");
    const message = error ? ERROR_MESSAGES[error] : undefined;
    if (message) {
      toast.error(message);
    }
  }, [toast]);

  useEffect(() => {
    if (signedIn) {
      window.location.replace(targetAfterSignIn());
    }
  }, [signedIn]);

  return (
    <div class="flex justify-center min-h-screen">
      <div class="bg-white dark:bg-neutral-900 rounded-lg shadow-md dark:shadow-xl pt-4 px-4 w-full">
        <AuthView />
      </div>
    </div>
  );
};
